import { debounce } from "throttle-debounce";
import g from "../globals/variables";

const Search = target => {
  const el = {
    searchButton: target.querySelector("a.search__button"),
    searchDropdown: target,
    searchForm: target.querySelector(".search__form"),
    searchInput: target.querySelector(".search__input input"),
    searchResultsList: target.querySelector(".search__results-list"),
    searchResultsNumbers: target.querySelectorAll(".search__results-number"),
    searchResultsPhrase: target.querySelector(".search__results-phrase"),
    searchSeeAll: target.querySelector(".search__see-all"),
    searchSeeAllLink: target.querySelector(".search__see-all a"),
  };

  let currentActiveNavigation = null;
  let loaderTimeout = null;

  const method = {
    init: () => {
      if (el.searchInput) {
        el.searchInput.addEventListener("keyup", event => {
          if (event.target.value.length > 1) {
            if (loaderTimeout) clearTimeout(loaderTimeout);
            el.searchButton.classList.add("search__button--loading");
          } else {
            el.searchButton.classList.remove("search__button--loading");
          }
        });
        el.searchInput.addEventListener("keyup", debounce(500, method.performSearch));
        if (el.searchForm)
          el.searchForm.addEventListener("submit", event => event.preventDefault());
      }

    },

    performSearch: event => {
      const formData = new FormData(el.searchForm);

      if (event.target.value.length > 1) {
        method.changeSearchQuery(event.target.value);
        el.searchDropdown.classList.add("search--performed");

        fetch(el.searchForm.getAttribute("action"), {
          method: el.searchForm.getAttribute("method"),
          body: formData,
        })
          .then(response => response.json())
          .then(data => {
            method.renderSearchResults(data.result.results, data.result.count, event.target.value);
            loaderTimeout = setTimeout(() => {
              el.searchButton.classList.remove("search__button--loading");
            }, 500);
          })
          .catch(err => {
            // eslint-disable-next-line no-console
            console.log("Something went wrong!", err);
          });

        if (event.key === "Enter") el.searchButton.click();
      } else {
        el.searchDropdown.classList.remove("search--performed");
        el.searchResultsList.innerHTML = "";
        el.searchButton.setAttribute("href", el.searchButton.getAttribute("href").split("=")[0]);
        el.searchSeeAllLink.setAttribute(
          "href",
          el.searchSeeAllLink.getAttribute("href").split("=")[0],
        );
      }
    },

    changeSearchQuery: phrase => {
      let link = el.searchButton.getAttribute("href");
      const linkNew = `${link.split("=")[0]}=${phrase}`;
      el.searchButton.setAttribute("href", linkNew);
      el.searchSeeAllLink.setAttribute("href", linkNew);
    },

    renderSearchResults: (results, count, phrase) => {
      const displayCount = window.innerWidth < g.resolution.l ? 8 : 4;

      el.searchResultsPhrase.innerHTML = phrase;

      el.searchResultsNumbers.forEach(item => {
        const wrapper = item;
        wrapper.innerHTML = count;
      });

      el.searchResultsList.innerHTML = "";

      if (count < 1) {
        el.searchDropdown.classList.add("search--no-results");
      } else {
        el.searchDropdown.classList.remove("search--no-results");
      }

      if (count <= displayCount) {
        el.searchSeeAll.classList.add("search__see-all--hidden");
      } else {
        el.searchSeeAll.classList.remove("search__see-all--hidden");
      }

      if (results) {
        results.forEach((result, index) => {
          if (index < displayCount) {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${result.url}" class="custom">${result.name}<br><span>${result.url}</span></a>`;
            el.searchResultsList.appendChild(li);
          }
        });
      }
    },

  };

  method.init();
};

export default Search;
